import { Button, ButtonVariant, Size } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { IContentSelect, ILanding, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { useLandingStore } from "src/modules/pe-landing-module/data/store"
import { components } from "src/modules/pe-landing-module/data/utils/components"

/* Protopia Ecosystem component */
export interface IContentEditBreadcrumbsProps {
   deselect: () => void
}
const ContentEditBreadcrumbs = (props: IContentEditBreadcrumbsProps): JSX.Element => { 
    return <div className='landing-content-edit-breadcrumbs'>
        <Button size={Size.SMALL} variant={ButtonVariant.MINIMAL} className="btn-stretch small mr-1" onClick={props.deselect}>
            <i className="fas fa-home text-light" />
        </Button>
        <i className="fas fa-chevron-right text-light mr-1 opacity_5" />
        <EditContentLabel />
    </div>
}
export default ContentEditBreadcrumbs

export const getEditedContent = () => {
    const currentLanding: ILanding              = useLandingStore.getState().currentLanding
    const editElement: IContentSelect | null    = useLandingStore.getState().editElement
    switch(editElement?.selectType) {
        case SELECT_TYPE.CONTENT:
            return currentLanding.sections.find(section => section.id === editElement.sectionId)?.data.find(meat => meat.id === editElement.id)
        default:
            return null
    }
}

export const EditContentLabel = (): JSX.Element => {
    const currentLanding: ILanding              = useLandingStore.getState().currentLanding
    const editElement: IContentSelect | null    = useLandingStore.getState().editElement
    switch(editElement?.selectType) {
        case SELECT_TYPE.CONTENT:
            const meat = currentLanding.sections.find(section => section.id === editElement.sectionId)?.data.find(meat => meat.id === editElement.id)
            return meat
                ?
                <div className="flex-centered mx-1">
                    <img 
                        src={ components()[meat.type].icon }
                        height={ 10 }
                        className=" ml-1 panel-icon"
                        alt=""
                    />
                    <div className="small letter-spacing-1 text-nowrap mx-1">
                        { __(components()[meat.type].title) }
                    </div>    
                </div>
                :
                <></>
        default:
            return <></>
    }
}